/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ScorecardFeedbackContent
 */
export interface ScorecardFeedbackContent {
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedbackContent
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedbackContent
     */
    sentenceId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedbackContent
     */
    ruleId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedbackContent
     */
    ledgerItemIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof ScorecardFeedbackContent
     */
    text?: string;
}

/**
 * Check if a given object implements the ScorecardFeedbackContent interface.
 */
export function instanceOfScorecardFeedbackContent(value: object): boolean {
    return true;
}

export function ScorecardFeedbackContentFromJSON(json: any): ScorecardFeedbackContent {
    return ScorecardFeedbackContentFromJSONTyped(json, false);
}

export function ScorecardFeedbackContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardFeedbackContent {
    if (json == null) {
        return json;
    }
    return {
        
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'sentenceId': json['sentenceId'] == null ? undefined : json['sentenceId'],
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
        'ledgerItemIndex': json['ledgerItemIndex'] == null ? undefined : json['ledgerItemIndex'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function ScorecardFeedbackContentToJSON(value?: ScorecardFeedbackContent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'utteranceId': value['utteranceId'],
        'sentenceId': value['sentenceId'],
        'ruleId': value['ruleId'],
        'ledgerItemIndex': value['ledgerItemIndex'],
        'text': value['text'],
    };
}

